import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create Class
export const createScormCourse = data => post(url.CREATE_SCORM_COURSE, data);
export const fetchAllScormCourse = () => get(url.FETCH_ALL_SCORM_COURSES);
export const deleteScormCourse = id => del(url.DELETE_SCORM_COURSE + id);